import React, { Component } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IOnShipstationVoidLabelsDTO from "../../../../models/DTO/IOnShipstationVoidLabelsDTO";
import IShipstationVoidLabelsDTO from "../../../../models/DTO/IShipstationVoidLabelsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import INotification from "../../../../models/INotification";
import IShipment_Group from "../../../../models/IShipment_Group";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import "./VoidLabelsModal.scss";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    shipmentGroup: IShipment_Group;
};

type State = {
    active: boolean;
};

class VoidLabelsModal extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            active: false,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.ShipstationOnVoidLabels, this.onVoidLabels);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.ShipstationOnVoidLabels, this.onVoidLabels);
    }

    closeModal = () => {
        this.props.closeModalFn();
    };

    confirm = () => {
        const shipmentIds = (this.props.shipmentGroup.Shipments || [])
            .filter((shipment) => {
                return shipment.shipstation_shipmentId;
            })
            .map((shipment) => {
                return shipment.shipstation_shipmentId;
            });

        const payload: IShipstationVoidLabelsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            shipmentIds,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationVoidLabels, payload);

        this.setState({
            active: true,
        });
    };

    onVoidLabels = (data: IOnShipstationVoidLabelsDTO) => {
        const notification: INotification = {
            message: "successfully_voided_shipstation_labels",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.closeModal();
    };

    render() {
        return (
            <div className={"VoidLabelsModal p-2"}>
                <div className={"w-100"} style={{ minHeight: "2rem" }}>
                    <div className={"d-flex justify-content-between"}>
                        <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"confirm_void_labels"} tag={"h3"} />
                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>

                <div>
                    <OwButton
                        title={"confirm"}
                        leftIconClass={"fad fa-check-circle"}
                        fn={this.confirm}
                        active={this.state.active}
                        disableOnActive={true}
                    />
                </div>
            </div>
        );
    }
}

export default VoidLabelsModal;
